import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const EnhancedTableToolbar = (props) => {
  const { numSelected, expireMessageHandler, deleteMessageHandler } = props;
  const { t } = useTranslation();
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {`${numSelected} ${t("admin.table.selected")}`}
        </Typography>
      ) : (
        <Typography
          sx={{ flex: "1 1 100%" }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {t("admin.table.manageMessages")}
        </Typography>
      )}
      {numSelected > 0 ? (
        <Box sx={{ display: "flex" }}>
          <Tooltip title={t("admin.table.expireSelectedMessages")}>
            <Button
              onClick={() => {
                expireMessageHandler();
              }}
            >
              Expire
            </Button>
          </Tooltip>
          <Tooltip title={t("admin.table.delete")}>
            <IconButton
              onClick={() => {
                deleteMessageHandler();
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ) : (
        <Tooltip title={t("admin.table.filterList")}>
          <IconButton>{/* <FilterListIcon /> */}</IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

export default EnhancedTableToolbar;
